const isServer = () => typeof window !== 'object';

export default isServer;
